import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
import { Router, NavigationEnd, ActivatedRoute  } from '@angular/router';
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-club',
	templateUrl: './club.component.html',
	styleUrls: ['./club.component.scss']
})
export class ClubComponent implements OnInit {

	statementList: any = "";
	premieroutdoorList: any = "";
	premieroutdoorimgList: any = "";
	premieroutdoorimgsecList: any = "";
	premieroutdoorimgthirdList: any = "";
	contactRequest: any = {};
	contactError: any;
	contactSuccess: any;
	groundregulationsList: any = "";
	directionsList: any = "";
	directionsfirstList: any = "";
	directionssecList: any = "";

	bannerrequest: any = {};
	bannerList: any = "";
	bannereventList: any = "";
	route: string;
    currentURL='';
	newurl: any = "";
	constructor(private allpagesService: AllPageService,
		private activatedRoute:ActivatedRoute,
    private router: Router,) { 
		this.currentURL = window.location.href;
		//console.log(this.currentURL);
		this.newurl = this.currentURL.split("/", 5); 
		this.tabactive(this.newurl[4]);
		console.log(this.newurl[4]);
		
	}
	slidefacilitiesConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideconcertsConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidePefectConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	ngOnInit() {
		
		
		//this.route.parent.snapshot.url[2].path;
		this.activatedRoute.params.subscribe((data)=>{
			//console.log(data);
			if(data.slug){
				this.tabactive(data.slug);
			  //console.log(data.slug);
			  //this.newsRequest = data.slug;
			}
			
			});
		this.loadBanner();
		this.loadBannerevent();


		this.allpagesService.getClubAccessstatement().then((data) => {
			this.statementList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);

		});

		this.allpagesService.getClubPremieroutdoor().then((data) => {
			this.premieroutdoorList = data;
			console.log(this.premieroutdoorList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);

		});

		this.allpagesService.getClubPremieroutdoorimg().then((data) => {
			this.premieroutdoorimgList = data.data[0];
			this.premieroutdoorimgsecList = data.data[1];
			this.premieroutdoorimgthirdList = data.data[2];
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);

		});

		this.allpagesService.getClubGroundregulations().then((data) => {
			this.groundregulationsList = data;
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);

		});

		this.allpagesService.getClubDirections().then((data) => {
			this.directionsList = data;
			this.directionsfirstList = data.data.club_directions[0];
			this.directionssecList = data.data.club_directions[1];
			console.warn(this.directionssecList);
			setTimeout(() => {
				this.tabactive(this.newurl[4]);
					var accordionParentClass = '.directions-faq .faq-title';
					var accordionQuestionClass = '.directions-faq .faq-title .faq-add';
					var accordionContentClass = '.directions-faq .faq-content';
				
					jQuery(accordionParentClass).each(function() {
					jQuery( this ).addClass('close');
					jQuery( this ).find(accordionContentClass).hide();
					});
					
					jQuery(accordionQuestionClass).click(function(){
					var faqClass = jQuery(this).closest(accordionParentClass).attr('class');
					
					if(faqClass.indexOf('close') != -1){
						//WHEN CLOSED
						jQuery(accordionParentClass).find(accordionContentClass).slideUp('slow'); //CLOSE ALL
						jQuery(accordionParentClass).addClass('close').removeClass('open'); //set all faq as closed
						
						jQuery(this).closest(accordionParentClass).removeClass('close');
						jQuery(this).closest(accordionParentClass).addClass('open');
						// jQuery( this ).closest(accordionParentClass).find(accordionContentClass).slideDown('slow');
						
					} else {
						jQuery(this).closest(accordionParentClass).addClass('close');
						jQuery(this).closest(accordionParentClass).removeClass('open');
						// jQuery( this ).closest(accordionParentClass).find(accordionContentClass).slideUp('slow');
					}
					
					});
				
   
				
					var accordionParentClasstwo = '.directions-two-faq .faq-title';
					var accordionQuestionClasstwo = '.directions-two-faq .faq-title .faq-add';
					var accordionContentClasstwo = '.directions-two-faq .faq-content';
				
					jQuery(accordionParentClasstwo).each(function() {
					jQuery( this ).addClass('close');
					jQuery( this ).find(accordionParentClasstwo).hide();
					});
					
					jQuery(accordionQuestionClasstwo).click(function(){
					var faqClass = jQuery(this).closest(accordionParentClasstwo).attr('class');
					
					if(faqClass.indexOf('close') != -1){
						//WHEN CLOSED
						jQuery(accordionParentClasstwo).find(accordionParentClasstwo).slideUp('slow'); //CLOSE ALL
						jQuery(accordionParentClasstwo).addClass('close').removeClass('open'); //set all faq as closed
						
						jQuery(this).closest(accordionParentClasstwo).removeClass('close');
						jQuery(this).closest(accordionParentClasstwo).addClass('open');
						// jQuery( this ).closest(accordionParentClasstwo).find(accordionParentClasstwo).slideDown('slow');
						
					} else {
						jQuery(this).closest(accordionParentClasstwo).addClass('close');
						jQuery(this).closest(accordionParentClasstwo).removeClass('open');
						// jQuery( this ).closest(accordionParentClasstwo).find(accordionParentClasstwo).slideUp('slow');
					}
					
					}); 
				
				
					var accordionParentClassthree = '.ground-faq .faq-title';
					var accordionQuestionClassthree = '.ground-faq .faq-title .faq-add';
					var accordionContentClassthree = '.ground-faq .faq-content';
				
					jQuery(accordionParentClassthree).each(function() {
					jQuery( this ).addClass('close');
					jQuery( this ).find(accordionParentClassthree).hide();
					});
					
					jQuery(accordionQuestionClassthree).click(function(){
					var faqClass = jQuery(this).closest(accordionParentClassthree).attr('class');
					
					if(faqClass.indexOf('close') != -1){
						//WHEN CLOSED
						jQuery(accordionParentClassthree).find(accordionParentClassthree).slideUp('slow'); //CLOSE ALL
						jQuery(accordionParentClassthree).addClass('close').removeClass('open'); //set all faq as closed
						
						jQuery(this).closest(accordionParentClassthree).removeClass('close');
						jQuery(this).closest(accordionParentClassthree).addClass('open');
						// jQuery( this ).closest(accordionParentClassthree).find(accordionParentClassthree).slideDown('slow');
						
					} else {
						jQuery(this).closest(accordionParentClassthree).addClass('close');
						jQuery(this).closest(accordionParentClassthree).removeClass('open');
						// jQuery( this ).closest(accordionParentClassthree).find(accordionParentClassthree).slideUp('slow');
					}
					
					}); 
				

				

				
				jQuery(".directionssec-faq .faq-title ").on("click", function () {
					jQuery(".directionssec-faq .faq-title").removeClass('active');
					if (jQuery(this).toggleClass('active')) {
						// do nothing
					}
					return false;
				});
				


			}, 1000);

		});


		jQuery(".courses-name").click(function () {
			if (jQuery(this).hasClass('active')) {
				// do nothing
			} else {
				var tabid = jQuery(this).attr('id');
				jQuery(".courses-name").removeClass('active');
				jQuery(this).addClass('active');
				jQuery(".course-main-content").removeClass('active');
				jQuery("#" + tabid + "-content").addClass("active");
			}
			return false;
		});


	}

	tabactive(slug) {
		//console.log(slug);
		jQuery(".courses-name").removeClass('active');
		jQuery(".course-main-content").removeClass('active');
			if(slug == 'directions'){
			jQuery("#directions").addClass('active');
			jQuery("#directions-content").addClass("active");		
		}else if(slug == 'ground-regulations'){
			jQuery("#ground-regulations").addClass('active');
			jQuery("#ground-regulations-content").addClass("active");
		}else if(slug == 'access-statement'){
			jQuery("#access-statement").addClass('active');
			jQuery("#access-statement-content").addClass("active");
		}
		else if(slug == 'premier-outdoor-venue'){
			jQuery("#premier-outdoor").addClass('active');
			jQuery("#premier-outdoor-content").addClass("active");
		}
		// else{
		// 	jQuery("#premier-outdoor").addClass('active');
		// 	jQuery("#premier-outdoor-content").addClass("active");
		// }
	}

	clubContactus(form: NgForm) {
		if (form.valid) {

			let request: any = {};
			request = Object.assign({}, this.contactRequest);
			this.allpagesService.getClubContactus(request).then((res) => {

				if (res.status == 0) {
					this.contactError = res.message;
				} else {
					this.contactSuccess = res.message;
					form.reset();
				}
			})
				.catch((err) => {
					this.contactError = err.res.message;
				});
		}
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Uptonsteel County Ground'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
			//console.log(this.bannerList);
		});
	}

	loadBannerevent() {
		this.bannerrequest = {
			title: 'Uptonsteel County Ground Events'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannereventList = data.data[0];
			//console.log(this.bannerList);
			setTimeout(() => {
				
				this.tabactive(this.newurl[4]);
			}, 1000);
		});
	}


}
